"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPrefixMapException = void 0;
const ts_error_1 = __importDefault(require("ts-error"));
class InvalidPrefixMapException extends ts_error_1.default {
    constructor(tenant) {
        super(`Cannot get prefix from the given tenant: ${tenant}`);
    }
}
exports.InvalidPrefixMapException = InvalidPrefixMapException;
//# sourceMappingURL=invalid-prefix-map.exception.js.map